import { Injectable } from '@angular/core';
import { RecordingListItem } from './interfaces/recording-list-item.interface';
import { BcRestApi } from 'common/api/rest-api';

@Injectable()
export class RecordingsListService {
  constructor(private bcRestApi: BcRestApi) {
  }

  loadRecordings(): Promise<RecordingListItem[]> {
    return this.bcRestApi.getRemoteControlHistoryForAccount();
  }
}
